import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import TableWidget from "../../components/tables/TableWidget";
import FormHeader from "../../components/misc/FormHeader";
import { generalRoutes } from "../../router/routesConstants";
import {
  binHistoryTableHeader,
  getBinTableData,
} from "./components/tableConfigs/binHistoryTableConfig";
import { TableActions } from "../../components/tables/tableContext/TableContext";
import { fetchBinHistory } from "../../redux/api/general.api";
import BinHistoryActionButtons from "./components/ActionButtons/BinHistoryActionButtons";
import { getBinStatuses } from "../../redux/api/expedition.api";

function BinHistoryTable() {
  const dispatch = useAppDispatch();

  const {
    general: {
      binHistory: {
        data: { data: dataBin, total: totalBin },
        isLoading: isLoadingBin,
      },
    },
    expedition: {
      workingRoutesNodes: {
        data: { data: clientsNodesData },
        isLoading: isLoadingNodes,
      },
      binStatuses: { data: binStatusesData, isLoading: isLoadingBinStatus },
    },
  } = useAppSelector((state) => ({
    general: state.general,
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(getBinStatuses());
  }, [dispatch]);

  const binHistoryTableHeaderNew = useMemo(
    () =>
      binHistoryTableHeader.map((item) => {
        if (!isLoadingNodes && item.value === "nodDestinatie") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }

        if (!isLoadingNodes && item.value === "nodPreluare") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }

        if (!isLoadingBinStatus && item.value === "status") {
          const binStatusesDropdown = binStatusesData?.map(
            ({ denumire, valoare }) => ({
              label: denumire,
              value: valoare,
            }),
          );
          return {
            withFilter: [
              { label: "Toate", value: "all" },
              ...binStatusesDropdown,
            ],
            ...item,
          };
        }
        return item;
      }),

    [binStatusesData, clientsNodesData, isLoadingBinStatus, isLoadingNodes],
  );

  const handleBinTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch &&
      action.tableFilter
    ) {
      dispatch(
        fetchBinHistory({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          sn_bin: action.tableSearch.sn_bin,
          nodDestinatie: action.tableFilter.nodDestinatie,
          nodPreluare: action.tableFilter.nodPreluare,
          status: action.tableFilter.status,
        }),
      );
    }
  };

  return (
    <TableWidget
      CustomHeaderComponent={() => (
        <FormHeader
          title="Istoric BIN-uri"
          buttonIcon="ADD"
          buttonRoute={`/${generalRoutes.createBin}`}
          buttonTooltip="Creeaza BIN"
        />
      )}
      tableHeaderData={binHistoryTableHeaderNew}
      tableItemsData={getBinTableData(dataBin)}
      totalItems={totalBin}
      tableLoading={isLoadingBin}
      handleTableActions={handleBinTableActions}
      ActionButtonsComponent={(props: any) => (
        <BinHistoryActionButtons {...props} />
      )}
      borderedRow
    />
  );
}

export default BinHistoryTable;
